// src/api/brandApi.js
import axiosInstance from "./axiosConfig";

export const createBrand = (brandData) => {
  return axiosInstance.post("/brands", brandData); // La URL final será http://localhost:3001/api/brands
};

export const getBrands = () => {
  return axiosInstance.get("/brands"); // La URL final será http://localhost:3001/api/brands
};
